import { OLAF, OZ } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import TranslatedFeature from '../feature-table/TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureInterestSection = ({
  featureInterest,
  width
}) => {
  const maxNumFeaturesToShow = 5;
  const maxAdditionalFeaturesToShow = 15;
  const firstFiveFeatureInterests = featureInterest.slice(0, maxNumFeaturesToShow);
  const additionalFeatureInterests = featureInterest.length > maxNumFeaturesToShow ? featureInterest.slice(maxNumFeaturesToShow, maxNumFeaturesToShow + maxAdditionalFeaturesToShow) : [];
  const AdditionalFeatureInterestToolTipText = () => {
    return /*#__PURE__*/_jsx("ul", {
      style: {
        listStyleType: 'none',
        padding: '0px'
      },
      children: additionalFeatureInterests.map(({
        growthFeatureWithDefaultDescription: feature
      }) => {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(TranslatedFeature, {
            feature: feature,
            attribute: "name"
          })
        }, feature.shortName);
      })
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      width
    },
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-5",
      "aria-level": 3,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.featureInterestSection.header"
      })
    }), /*#__PURE__*/_jsx("ul", {
      className: "m-bottom-0 p-bottom-0",
      style: {
        listStyleType: 'none',
        padding: '0px'
      },
      children: firstFiveFeatureInterests.map(({
        growthFeatureWithDefaultDescription: feature
      }) => {
        return /*#__PURE__*/_jsx("li", {
          className: "m-bottom-6",
          children: /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(TranslatedFeature, {
              feature: feature,
              attribute: "description"
            }),
            placement: "left",
            children: /*#__PURE__*/_jsx(UIMediaObject, {
              itemLeft: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "success",
                color: OLAF,
                backgroundColor: OZ,
                size: 12,
                padding: 0.25
              }),
              children: /*#__PURE__*/_jsx(TranslatedFeature, {
                feature: feature,
                attribute: "name"
              })
            })
          })
        }, feature.shortName);
      })
    }), additionalFeatureInterests.length > 0 && /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(AdditionalFeatureInterestToolTipText, {}),
      placement: "bottom",
      children: /*#__PURE__*/_jsx(UILink, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "ebxInterstitialPage.featureInterestSection.andMoreFeatures",
          options: {
            count: additionalFeatureInterests.length
          }
        })
      })
    })]
  });
};
export default FeatureInterestSection;